import { fetchPageAssets } from "../../ducks/hostedAssets.duck";
import { showListing } from "../ListingPage/ListingPage.duck";

export const ASSET_NAME = 'landing-page';

// ================ Action types ================ //

export const FETCH_ORDERS_OR_SALES_REQUEST = 'app/InboxPage/FETCH_ORDERS_OR_SALES_REQUEST';
export const FETCH_ORDERS_OR_SALES_SUCCESS = 'app/InboxPage/FETCH_ORDERS_OR_SALES_SUCCESS';
export const FETCH_ORDERS_OR_SALES_ERROR = 'app/InboxPage/FETCH_ORDERS_OR_SALES_ERROR';

// ================ Reducer ================ //

const initialState = {

};

export default function inboxPageReducer(state = initialState, action = {}) {
    const { type, payload } = action;
    switch (type) {
        default:
            return state;
    }
}

// ================ Action creators ================ //

const fetchOrdersOrSalesRequest = () => ({ type: FETCH_ORDERS_OR_SALES_REQUEST });
const fetchOrdersOrSalesSuccess = response => ({
    type: FETCH_ORDERS_OR_SALES_SUCCESS,
    payload: response,
});
const fetchOrdersOrSalesError = e => ({
    type: FETCH_ORDERS_OR_SALES_ERROR,
    error: true,
    payload: e,
});

// ================ Thunks ================ //

export const fetchImage = (listingId, config) => async (dispatch, getState, sdk) => {
    const listingResponse = await dispatch(showListing(listingId, config));
    const listing = listingResponse.data.included;
    const listingImage = listing[0];
    return [listingImage];
};

export const loadData = (params, search) => (dispatch, getState, sdk) => {
    const { userType } = params;
    const pageAsset = { landingPage: `content/pages/${ASSET_NAME}.json` };
    return dispatch(fetchPageAssets(pageAsset, true));
    // return dispatch(fetchCurrentUser());
};
